<template>
    <div
            class="landing-page-ready-to-get-started 3xl:tw-max-w-[120rem] xl:tw-flex-row xl:tw-px-14 tw-h-full tw-py-10 tw-px-5 sm:tw-px-[5.62rem] tw-w-full tw-bg-[#064789] tw-flex tw-flex-col tw-justify-center tw-items-center"
            :style="{ background: landingPage.primaryColor, ...primaryColorStyle }"
    >
        <h1 class="ready-to-get-started-title 3xl:tw-text-[2.8rem] 3xl:tw-leading-[3.85rem] xl:tw-mr-[3rem] tw-text-white tw-text-center xl:tw-m-0 tw-mb-10 tw-font-poppins tw-text-[2.5rem] tw-leading-10 tw-font-semibold tw-tracking-[-0.125rem] md:tw-max-w-[27rem] tw-max-w-[23rem]">
            Ready to get started?
        </h1>
        <div
                class="address-search-wrapper"
                :class="!isCustomAddressSelected ?
                    'md:tw-max-w-[48rem] md:tw-flex-row md:tw-justify-between tw-max-h-44 tw-rounded-[0.62rem] tw-bg-white tw-flex lg:tw-flex-row tw-flex-col tw-shadow-[0px_53.6px_52.607px_-22.83px_rgba(22,28,45,0.50)] tw-w-full lg:tw-max-w-[48rem] tw-items-center tw-gap-4 tw-p-4'
                    : 'tw-flex tw-flex-col tw-gap-4 tw-p-6 md:tw-p-8 tw-border tw-border-gray-200 tw-rounded-xl lg:tw-shadow-[0px_53.6px_52.607px_-22.83px_rgba(22,28,45,0.50)] tw-bg-white tw-overflow-visible'"
        >
            <div
                    class="address-type-ahead-wrapper"
                    :class="{ 'tw-w-full md:tw-max-w-[32.625rem] tw-max-h-16 tw-flex md:tw-w-[32.625rem] lg:tw-max-w-[32.625rem] tw-h-[4rem] tw-items-center tw-gap-4 tw-rounded-[0.64rem] tw-border tw-border-[#C3C5C9] tw-bg-white': !isCustomAddressSelected }"
                    :style="!isCustomAddressSelected ? { borderRadius: '0.64rem', border: '1.28px solid #C3C5C9' } : {}"
            >
                <custom-address-type-ahead
                        id="custom-address-get-started"
                        swap-text-class="address-swap"
                        search-label=""
                        address-ref="addressTypeAhead"
                        city-state-label="City & State"
                        zip-label="ZIP Code"
                        street-label="Street Address"
                        ref="customAddressTypeAhead"
                        placeholder="Enter your home address"
                        :value="address"
                        :errors="errors"
                        :class="{'border-danger': hasAddressError}"
                        :show-enter-manually-button="false"
                        :has-focusable-state="false"
                        has-custom-before-slot
                        prefill-address
                        @update:errors="$emit('update:errors', $event)"
                        @is-zip-code-valid="isZipCodeValid = $event"
                        @select-address="handleAddressInput"
                        @is-custom-address-selected="onCustomAddressSelected"
                >

                    <template #before>
                        <div class="tw-w-[2.1rem] tw-h-[2.4rem] tw-flex tw-justify-center tw-items-center">
                            <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="26"
                                    height="34"
                                    viewBox="0 0 26 34"
                                    fill="none"
                            >
                                <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M12.9307 0.418884C6.76575 0.418884 0.388306 5.07138 0.388306 12.8568C0.388306 21.1133 11.9177 32.6418 12.4091 33.1283C12.5471 33.2659 12.7352 33.3427 12.9307 33.3427C13.1262 33.3427 13.3144 33.2659 13.4523 33.1283C13.9437 32.6418 25.4731 21.1133 25.4731 12.8568C25.4731 5.07138 19.0957 0.418884 12.9307 0.418884ZM12.9308 17.2466C10.4895 17.2466 8.50408 15.2778 8.50408 12.8568C8.50408 10.4358 10.4895 8.46696 12.9308 8.46696C15.3721 8.46696 17.3575 10.4358 17.3575 12.8568C17.3575 15.2778 15.3721 17.2466 12.9308 17.2466Z"
                                        :fill="landingPage.primaryColor || '#064789'"
                                />
                            </svg>
                        </div>
                    </template>
                </custom-address-type-ahead>

                <form-errors
                        :errors="errors"
                        field="address"
                />

                <div
                        v-if="isCustomAddressSelected"
                        class="d-flex justify-content-center pt-2"
                >
                    <button
                            aria-label="Cancel"
                            class="cancel-btn tw-bg-white tw-border-none tw-font-poppins tw-font-semibold tw-px-4 tw-py-2 tw-mr-4 tw-rounded-md tw-transition tw-duration-200 hover:tw-bg-gray-100"
                            @click="resetAddress"
                    >
                        Cancel
                    </button>
                    <button
                            aria-label="Claim my home"
                            class="claim-my-hub-btn tw-border-none tw-w-auto tw-px-6 tw-h-12 tw-rounded-md tw-bg-[#064789] tw-flex tw-justify-center tw-items-center tw-text-white tw-font-poppins tw-font-semibold tw-text-base"
                            :style="{ background: landingPage.primaryColor, opacity: !isZipCodeValid ? '0.6' : '' }"
                            @click="onCustomAddressClaimMyHome"
                    >
                        Claim my home
                    </button>
                </div>
            </div>
            <button
                    v-if="!isCustomAddressSelected"
                    aria-label="Claim my home"
                    class="claim-my-hub-btn tw-border-none md:tw-max-w-[12.8rem] tw-max-h-16 tw-w-full md:tw-w-full tw-rounded-lg tw-bg-[#064789] lg:tw-w-[12.8125rem] tw-h-16 tw-flex tw-justify-center tw-items-center tw-text-white tw-font-poppins tw-font-bold tw-text-xl"
                    :style="{background: landingPage.primaryColor}"
                    @click="handleClaimMyHomeClick"
            >
                Claim my home
            </button>
        </div>
    </div>
</template>

<script>
import HOHAddressMixin from "../Home/HomeTypes/HomeOwnershipHome/HOHAddressMixin";
import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";
import claimMyHomeMixin from "./claimMyHomeMixin";
import FormErrors from '@milestoneslabs/milestones-ui-kit/src/components/FormErrors/FormErrors';
import CustomAddressTypeAhead from
    "@milestoneslabs/milestones-ui-kit/src/components/CustomAddressTypeAhead/CustomAddressTypeAhead";
import AddressAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/AddressAppResource";

export default {
    name: 'LandingPageReadyToGetStarted',
    components: {
        CustomAddressTypeAhead,
        FormErrors,
    },
    mixins: [
        HOHAddressMixin,
        claimMyHomeMixin,
    ],
    props: {
        landingPage: {
            type: LandingPageAppResource,
            required: true,
        }
    },
    data() {
        return {
            address: new AddressAppResource({}),
            errors: {},
            isZipCodeValid: false,
            isCustomAddressSelected: false
        };
    },
    computed: {

    },
    methods: {
    },
}
</script>
<style lang="scss">
.landing-page-ready-to-get-started {
    .address-search-wrapper {
        .address-type-ahead-wrapper {
            .custom-address {
                @apply tw-font-poppins;
                & label {
                    @apply tw-text-[#595959] tw-font-bold;
                }
                & #company-second-street-input {
                    @apply tw-mb-4;
                }
                & .form-group input:not(.type-ahead__input) {
                    @apply tw-border tw-border-[#C3C5C9] tw-rounded-lg tw-bg-white tw-px-4 tw-text-base tw-font-poppins tw-text-gray-900 tw-transition tw-duration-200;
                }

                & .form-group input:not(.type-ahead__input):focus {
                    border-color: var(--landing-page-primary-color);
                    box-shadow: 0 0 0 1px var(--landing-page-primary-color);
                }
                .address-swap {
                    color: var(--landing-page-primary-color) !important;
                    &.text-address {
                        @apply tw-pt-4 tw-pb-4 tw-mt-0;
                    }
                }
                .company-form-group {
                    @apply tw-mb-0;
                    .type-ahead {
                        @apply tw-flex-grow tw-p-4;
                        .input-group {
                            @apply tw-flex tw-justify-between tw-items-center;
                            .type-ahead__input {
                                @apply tw-text-[#595959] tw-text-base tw-font-normal tw-leading-[1.92rem] tw-border-none;
                                padding-left: 1rem !important;
                            }
                        }
                    }
                }
                .city-state-group {
                    @apply tw-relative tw-w-full;
                    #city-state-dropdown {
                        @apply tw-absolute tw-rounded-xl tw-min-w-full tw-left-0 tw-right-0 tw-z-10 tw-mt-2;
                    }
                }
            }
        }
    }
}
</style>
